import { render, staticRenderFns } from "./vueDialog.vue?vue&type=template&id=4b2b11a7&scoped=true&"
import script from "./vueDialog.vue?vue&type=script&lang=js&"
export * from "./vueDialog.vue?vue&type=script&lang=js&"
import style0 from "./vueDialog.vue?vue&type=style&index=0&id=4b2b11a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2b11a7",
  null
  
)

export default component.exports